import React from "react";
import LegalLayout, { LegalSection } from "@/components/LegalLayout";
import { Scale } from "lucide-react";

export default function GrievanceRedressal() {
  return (
    <LegalLayout title="Grievance Redressal" testid="grievance-page" icon={Scale} updated="2026">
      <LegalSection heading="Grievance Officer">
        <div className="rounded-xl bg-secondary p-4 space-y-1">
          <p><strong>Name:</strong> Narendra Aribina</p>
          <p><strong>Designation:</strong> Grievance Redressal Officer</p>
          <p><strong>Email:</strong> <a href="mailto:aribina.narendra@gmail.com" className="text-brand-emerald hover:underline" data-testid="grievance-email">aribina.narendra@gmail.com</a></p>
          <p><strong>Postal Address:</strong> Andhra Pradesh, India</p>
        </div>
      </LegalSection>

      <LegalSection heading="How to Report a Violation">
        <p>To report a violation, email the Grievance Officer with:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>The <strong>listing URL</strong> of the content in question, and</li>
          <li>Supporting <strong>proof</strong> of the violation.</li>
        </ul>
        <p>Action will be taken within <strong>36 hours</strong> of receiving a valid complaint.</p>
      </LegalSection>

      <LegalSection heading="Legal Basis">
        <p>This grievance redressal mechanism is provided as mandated under the <strong>Information Technology Act, 2000</strong> and applicable Intermediary Guidelines.</p>
      </LegalSection>
    </LegalLayout>
  );
}
